(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/my-receivers-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/my-receivers-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.MyReceiversList = Marionette.CollectionView.extend({
    childView: svs.grassroots.views.MyReceiverItem,
    childViewOptions: function(model) {
      return {
        attributes: {
          'aria-expanded': 'false',
          'aria-controls': `grassroots-my-receivers-${model.id}`,
          'data-index': model.id
        },
        childIndex: model.id,
        className: `my-receivers accordion-item js-accordion-item-${model.id} js-accordion-item`,
        path: 'valj',
        tagName: 'li'
      };
    },
    tagName: 'ul',
    className: 'accordion accordion-customer-sport accordion-default js-receiver-accordion-my-receviers js-receiver-my-receivers js-accordion',
    emptyView: svs.grassroots.views.ReceiverToplistsEmpty,
    viewFilter: function(view) {
      return view.model.attributes.myReceiver;
    },
    collectionEvents: {
      change: 'render'
    },
    onAddChild: function(view) {
      for(var i = 0; i < view.el.children.length; i++) {
        const oldItem = view.el.children[i].firstChild;
        const newItem = oldItem.cloneNode(true);
        oldItem.parentNode.replaceChild(newItem, oldItem);
        setTimeout(function() {
          view.render();
        }, 200);
      }
    },
    onRender: function(view) {
      new svs.ui.Accordion({ el: view.el });
    }
  });
})(Backbone, _, svs);


 })(window);